export type BEATS = "BEATS";
export type ROFI  = "ROFI";
export type GENIUS = "GENIUS";

export type RadioChannelType = 
  BEATS |
  ROFI  |
  GENIUS
;


export class RadioChannels
{
  static readonly BEATS:BEATS = "BEATS";
  static readonly ROFI:ROFI = "ROFI";
  static readonly GENIUS:GENIUS = "GENIUS";
}